export default __webpack_public_path__ + "static/media/status_late.61331b24.svg";